import { render, staticRenderFns } from "./VaChip.vue?vue&type=template&id=b22a5598&scoped=true&"
import script from "./VaChip.vue?vue&type=script&lang=ts&"
export * from "./VaChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22a5598",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b22a5598')) {
      api.createRecord('b22a5598', component.options)
    } else {
      api.reload('b22a5598', component.options)
    }
    module.hot.accept("./VaChip.vue?vue&type=template&id=b22a5598&scoped=true&", function () {
      api.rerender('b22a5598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/VaChip.vue"
export default component.exports